/**
 * Automy.Core.Enums.Reporting.Datasets.ReportingDatasetSyncStatus
 * JSON `state` on the tenant dataset row (string token).
 */
export default Object.freeze({
  NotSynced: 'not-synced',
  Synced: 'synced',
  Failed: 'failed',
});
